/* Instagram feed.

   Carried over from prototype/pages/home/home.js (loadInstagramFeed). The
   behaviour is unchanged: fetch the App Proxy endpoint, which keeps the Instagram
   token server-side, and replace the curated fallback cards with live media. If
   the request fails or returns nothing the fallback stays on screen, so the strip
   is never empty.

   Three differences, all forced by the move into a theme:
   - the post count comes from the section setting via data-instagram-limit
     instead of being hardcoded to 5
   - the file:// guard is gone, because a theme is always served over HTTP
   - it re-runs on shopify:section:load, so the theme editor cannot leave the
     section showing a dead feed after a settings change
*/

(() => {
  if (window.CaratKinInstagramFeed) return;

  async function loadInstagramFeed(root = document) {
    const section = root.querySelector?.("[data-instagram-feed]") ?? null;
    const scope = section || (root.matches?.("[data-instagram-feed]") ? root : null);
    if (!scope) return;

    const feed = scope.querySelector("[data-instagram-items]");
    if (!feed || feed.dataset.instagramLoaded === "true") return;

    const limit = Number(scope.dataset.instagramLimit) || 5;

    try {
      const response = await fetch(`/apps/cart-kin/instagram?limit=${limit}`, {
        headers: { Accept: "application/json" },
      });
      if (!response.ok) return;

      const payload = await response.json();
      if (!Array.isArray(payload.items) || !payload.items.length) return;

      const fragment = document.createDocumentFragment();
      payload.items.slice(0, limit).forEach((item) => {
        const link = document.createElement("a");
        link.href = item.permalink;
        link.target = "_blank";
        link.rel = "noreferrer";

        if (item.mediaType === "VIDEO" && item.mediaUrl) {
          const video = document.createElement("video");
          video.src = item.mediaUrl;
          video.poster = item.thumbnailUrl || "";
          video.muted = true;
          video.loop = true;
          video.autoplay = true;
          video.playsInline = true;
          video.setAttribute("aria-label", item.caption || "Carat and Kin Instagram video");
          link.append(video);
        } else {
          const image = document.createElement("img");
          image.src = item.mediaUrl || item.thumbnailUrl;
          image.alt = item.caption || "Carat and Kin Instagram post";
          image.loading = "lazy";
          link.append(image);
        }

        fragment.append(link);
      });

      // The marquee wraps the feed's children into a track, so the wrapper flag is
      // cleared and the marquee re-measured against the new content.
      feed.removeAttribute("data-ck-marquee-wrapped");
      feed.replaceChildren(fragment);
      feed.dataset.instagramLoaded = "true";
      window.CaratKinSiteExperience?.refreshMarquees(feed);
    } catch {
      // The curated fallback cards remain visible when the API is unavailable.
    }
  }

  window.CaratKinInstagramFeed = { load: loadInstagramFeed };
  loadInstagramFeed();

  document.addEventListener("shopify:section:load", (event) => loadInstagramFeed(event.target));
})();
